import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { noop, compact } from 'lodash';
import {
  compose,
  setDisplayName,
} from 'recompose';
import SearchBar from 'material-ui-search-bar';
import { withStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import Search from '@material-ui/icons/Search';

import { isMobile } from 'helpers/detect-mobile';

import {
  injectIntl,
  SearchBox,
  Tooltip,
} from 'components';

const styles = () => ({
  root: {
    flexDirection: 'row-reverse',
    transition: 'width 1s',
    zIndex: 1201,
  },
  rootMobile: {
    flexDirection: 'row-reverse',
    transition: 'width 1s',
    zIndex: 1201,
    position: 'absolute',
    left: 15,
    right: 0,
  },
  icon: {
    opacity: 1,
    color: '#333333 !important',
    width: 0,
  },
  iconOpen: {
    opacity: 1,
    color: '#333333 !important',
  },
  autoWidth: {
    width: 400,
    minWdith: 150,
    maxWidth: 600,
    transition: 'width 0.3s',
  },
  noWidth: { width: 0, transition: 'width 0.3s' },
  iconButton: { opacity: 1 },
  searchContainer: {
    width: 'calc(100% - 48px - 16px)',
    margin: 'auto 16px auto 0',
  },
  searchIconButton: {
    marginRight: 0,
    marginLeft: -48,
    padding: 0,
  },
});

class SearchComponent extends Component {
  static propTypes = {
    classes: PropTypes.shape({}).isRequired,
    cancelSearch: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    search: PropTypes.func.isRequired,
    searchText: PropTypes.string,
    tooltip: PropTypes.string,
  };

  static defaultProps = {
    placeholder: '',
    searchText: '',
    tooltip: '',
  }

  state = {
    isOpen: false,
  }

  openSearch = () => {
    this.setState({ isOpen: true }, () => {
      if (this.input) this.input.focus();
    });
  }
  closeSearch = () => this.setState({ isOpen: false });

  render() {
    const {
      classes,
      cancelSearch,
      placeholder,
      search,
      searchText,
      tooltip,
    } = this.props;
    const { isOpen } = this.state;

    return (
      <SearchBox>
        <div
          style={{ boxShadow: 'none' }}
          className="invoice-searchbar"
          key={window.location}
        >
          <IconButton
            className={isOpen ? 'toggle-search-open' : 'toggle-search-closed'}
            onClick={this.openSearch}
            style={{ display: isMobile ? 'block' : 'none' }}
          >
            <Search className="open-search-icon" style={{ color: 'whitesmoke' }} />
          </IconButton>
          <Tooltip
            placement="bottom-start"
            tooltip={tooltip || placeholder}
          >
            <SearchBar
              onCancelSearch={() => {
                cancelSearch();
                this.closeSearch();
              }}
              onChange={search}
              onBlur={this.closeSearch}
              inputRef={(c) => { this.input = c; }}
              onRequestSearch={isMobile ? this.closeSearch : noop}
              placeholder={placeholder}
              value={searchText}
              classes={{
                root: compact([
                  isMobile ? classes.rootMobile : classes.root,
                  isOpen || !isMobile ? classes.autoWidth : classes.noWidth,
                ]).join(' '),
                icon: isOpen || !isMobile ? classes.iconOpen : classes.icon,
                iconButton: classes.iconButton,
                searchContainer: classes.searchContainer,
                searchIconButton: classes.searchIconButton,
              }}
            />
          </Tooltip>
        </div>
      </SearchBox>
    );
  }
}

export default compose(
  setDisplayName('SearchComponent'),
  withStyles(styles),
  injectIntl,
)(SearchComponent);

